module.exports = __webpack_public_path__ + "static/img/kotok.e76c6449.webp";